import type { CurrencySettings } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { formatPrice as formatConfiguredPrice } from '@eliadmin/core/src/utils/price-utils';

type RealtyPriceValue = number | string | null | undefined;

const toFinitePrice = (value: RealtyPriceValue): number | null => {
  if (value === null || value === undefined || value === '') return null;

  const price = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(price) ? price : null;
};

/**
 * Keeps the Košice Real listing and detail price recipes identical. The Slovak
 * storefront is contracted to whole amounts grouped by spaces with the currency
 * after the amount. Other locales retain the canonical Core formatter.
 */
export const formatRealtyPrice = ({
  price,
  locale,
  currency,
  currencySettings,
}: {
  price: RealtyPriceValue;
  locale?: string | null;
  currency?: string | null;
  currencySettings?: CurrencySettings | null;
}): string | null => {
  const numericPrice = toFinitePrice(price);
  if (numericPrice === null) return null;

  if ((locale || 'sk').toLowerCase().startsWith('sk')) {
    const amount = new Intl.NumberFormat('sk-SK', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })
      .format(numericPrice)
      .replace(/[\u00a0\u202f]/g, ' ');

    return currency ? `${amount} ${currency}` : amount;
  }

  return formatConfiguredPrice(numericPrice, currency ?? '', currencySettings ?? null) || null;
};
